import { Typography } from '@mui/material';

import RowTableCell from './RowTableCell';
import { buildCellTitle } from '../../../utils/buildCellTitle';
import { TABLE_INPUT_CELL_SX } from '../../styles/tableInputs';

const CELL_SX = { px: 1, py: 0.75, fontSize: 13 };
const PRIMARY_SX = { fontSize: 13, lineHeight: 1.3 };
const SECONDARY_SX = { display: 'block', color: 'text.secondary', lineHeight: 1.3 };

/**
 * Celda de `CompactTable`: dato principal y, debajo, un dato secundario en gris, ambos cortados
 * con puntos suspensivos y completos en el `title`. Las columnas `editable` muestran el campo
 * que devuelve `render` sin recorte.
 * @param {Object} props
 * @param {Object} props.column Columna (`key`, `align`, `render`, `secondary`, `editable`).
 * @param {Object} props.row Renglón a mostrar.
 * @returns {JSX.Element}
 */
const CompactTableCell = ({ column, row }) => {
  const textAlign = column.align || 'left';
  if (column.editable) {
    return (
      <RowTableCell sx={{ textAlign, '&&': TABLE_INPUT_CELL_SX }}>
        {column.render(row)}
      </RowTableCell>
    );
  }
  const primary = column.render ? column.render(row) : row[column.key];
  const secondary = column.secondary?.(row);
  return (
    <RowTableCell title={buildCellTitle([primary, secondary])} sx={{ ...CELL_SX, textAlign }}>
      <Typography component="div" variant="body2" noWrap sx={PRIMARY_SX}>
        {primary ?? '—'}
      </Typography>
      {secondary ? (
        <Typography component="div" variant="caption" noWrap sx={SECONDARY_SX}>
          {secondary}
        </Typography>
      ) : null}
    </RowTableCell>
  );
};

export default CompactTableCell;
